/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import alby_config_json from "./alby/config.json";
import amie_config_json from "./amie/config.json";
import { metadata as applecalendar__metadata_ts } from "./applecalendar/_metadata";
import attio_config_json from "./attio/config.json";
import autocheckin_config_json from "./autocheckin/config.json";
import baa_for_hipaa_config_json from "./baa-for-hipaa/config.json";
import basecamp3_config_json from "./basecamp3/config.json";
import bolna_config_json from "./bolna/config.json";
import btcpayserver_config_json from "./btcpayserver/config.json";
import { metadata as caldavcalendar__metadata_ts } from "./caldavcalendar/_metadata";
import campfire_config_json from "./campfire/config.json";
import chatbase_config_json from "./chatbase/config.json";
import clic_config_json from "./clic/config.json";
import closecom_config_json from "./closecom/config.json";
import cron_config_json from "./cron/config.json";
import { metadata as dailyvideo__metadata_ts } from "./dailyvideo/_metadata";
import databuddy_config_json from "./databuddy/config.json";
import deel_config_json from "./deel/config.json";
import demodesk_config_json from "./demodesk/config.json";
import dialpad_config_json from "./dialpad/config.json";
import discord_config_json from "./discord/config.json";
import dub_config_json from "./dub/config.json";
import eightxeight_config_json from "./eightxeight/config.json";
import element_call_config_json from "./element-call/config.json";
import elevenlabs_config_json from "./elevenlabs/config.json";
import { metadata as exchange2013calendar__metadata_ts } from "./exchange2013calendar/_metadata";
import { metadata as exchange2016calendar__metadata_ts } from "./exchange2016calendar/_metadata";
import exchangecalendar_config_json from "./exchangecalendar/config.json";
import facetime_config_json from "./facetime/config.json";
import fathom_config_json from "./fathom/config.json";
import { metadata as feishucalendar__metadata_ts } from "./feishucalendar/_metadata";
import fonio_ai_config_json from "./fonio-ai/config.json";
import framer_config_json from "./framer/config.json";
import ga4_config_json from "./ga4/config.json";
import { metadata as giphy__metadata_ts } from "./giphy/_metadata";
import { metadata as googlecalendar__metadata_ts } from "./googlecalendar/_metadata";
import { metadata as googlevideo__metadata_ts } from "./googlevideo/_metadata";
import granola_config_json from "./granola/config.json";
import greetmate_ai_config_json from "./greetmate-ai/config.json";
import gtm_config_json from "./gtm/config.json";
import hitpay_config_json from "./hitpay/config.json";
import horizon_workrooms_config_json from "./horizon-workrooms/config.json";
import { metadata as hubspot__metadata_ts } from "./hubspot/_metadata";
import { metadata as huddle01video__metadata_ts } from "./huddle01video/_metadata";
import ics_feedcalendar_config_json from "./ics-feedcalendar/config.json";
import insihts_config_json from "./insihts/config.json";
import intercom_config_json from "./intercom/config.json";
import jelly_config_json from "./jelly/config.json";
import { metadata as jitsivideo__metadata_ts } from "./jitsivideo/_metadata";
import { metadata as larkcalendar__metadata_ts } from "./larkcalendar/_metadata";
import lindy_config_json from "./lindy/config.json";
import linear_config_json from "./linear/config.json";
import make_config_json from "./make/config.json";
import matomo_config_json from "./matomo/config.json";
import metapixel_config_json from "./metapixel/config.json";
import millis_ai_config_json from "./millis-ai/config.json";
import mirotalk_config_json from "./mirotalk/config.json";
import mock_payment_app_config_json from "./mock-payment-app/config.json";
import monobot_config_json from "./monobot/config.json";
import n8n_config_json from "./n8n/config.json";
import nextcloudtalk_config_json from "./nextcloudtalk/config.json";
import { metadata as office365calendar__metadata_ts } from "./office365calendar/_metadata";
import office365video_config_json from "./office365video/config.json";
import paypal_config_json from "./paypal/config.json";
import ping_config_json from "./ping/config.json";
import pipedream_config_json from "./pipedream/config.json";
import pipedrive_crm_config_json from "./pipedrive-crm/config.json";
import plausible_config_json from "./plausible/config.json";
import posthog_config_json from "./posthog/config.json";
import qr_code_config_json from "./qr_code/config.json";
import raycast_config_json from "./raycast/config.json";
import retell_ai_config_json from "./retell-ai/config.json";
import riverside_config_json from "./riverside/config.json";
import roam_config_json from "./roam/config.json";
import routing_forms_config_json from "./routing-forms/config.json";
import salesforce_config_json from "./salesforce/config.json";
import salesroom_config_json from "./salesroom/config.json";
import sendgrid_config_json from "./sendgrid/config.json";
import shimmervideo_config_json from "./shimmervideo/config.json";
import signal_config_json from "./signal/config.json";
import sirius_video_config_json from "./sirius_video/config.json";
import skype_config_json from "./skype/config.json";
import { metadata as stripepayment__metadata_ts } from "./stripepayment/_metadata";
import sylapsvideo_config_json from "./sylapsvideo/config.json";
import synthflow_config_json from "./synthflow/config.json";
import { metadata as tandemvideo__metadata_ts } from "./tandemvideo/_metadata";
import telegram_config_json from "./telegram/config.json";
import telli_config_json from "./telli/config.json";
import basic_config_json from "./templates/basic/config.json";
import booking_pages_tag_config_json from "./templates/booking-pages-tag/config.json";
import event_type_app_card_config_json from "./templates/event-type-app-card/config.json";
import event_type_location_video_static_config_json from "./templates/event-type-location-video-static/config.json";
import general_app_settings_config_json from "./templates/general-app-settings/config.json";
import link_as_an_app_config_json from "./templates/link-as-an-app/config.json";
import twipla_config_json from "./twipla/config.json";
import umami_config_json from "./umami/config.json";
import vimcal_config_json from "./vimcal/config.json";
import { metadata as vital__metadata_ts } from "./vital/_metadata";
import weather_in_your_calendar_config_json from "./weather_in_your_calendar/config.json";
import webex_config_json from "./webex/config.json";
import whatsapp_config_json from "./whatsapp/config.json";
import whereby_config_json from "./whereby/config.json";
import { metadata as wipemycalother__metadata_ts } from "./wipemycalother/_metadata";
import wordpress_config_json from "./wordpress/config.json";
import zapier_config_json from "./zapier/config.json";
import zoho_bigin_config_json from "./zoho-bigin/config.json";
import zohocalendar_config_json from "./zohocalendar/config.json";
import zohocrm_config_json from "./zohocrm/config.json";
import { metadata as zoomvideo__metadata_ts } from "./zoomvideo/_metadata";
export const appStoreMetadata = {
	alby: alby_config_json,
	amie: amie_config_json,
	applecalendar: applecalendar__metadata_ts,
	attio: attio_config_json,
	autocheckin: autocheckin_config_json,
	"baa-for-hipaa": baa_for_hipaa_config_json,
	basecamp3: basecamp3_config_json,
	bolna: bolna_config_json,
	btcpayserver: btcpayserver_config_json,
	caldavcalendar: caldavcalendar__metadata_ts,
	campfire: campfire_config_json,
	chatbase: chatbase_config_json,
	clic: clic_config_json,
	closecom: closecom_config_json,
	cron: cron_config_json,
	dailyvideo: dailyvideo__metadata_ts,
	databuddy: databuddy_config_json,
	deel: deel_config_json,
	demodesk: demodesk_config_json,
	dialpad: dialpad_config_json,
	discord: discord_config_json,
	dub: dub_config_json,
	eightxeight: eightxeight_config_json,
	"element-call": element_call_config_json,
	elevenlabs: elevenlabs_config_json,
	exchange2013calendar: exchange2013calendar__metadata_ts,
	exchange2016calendar: exchange2016calendar__metadata_ts,
	exchangecalendar: exchangecalendar_config_json,
	facetime: facetime_config_json,
	fathom: fathom_config_json,
	feishucalendar: feishucalendar__metadata_ts,
	"fonio-ai": fonio_ai_config_json,
	framer: framer_config_json,
	ga4: ga4_config_json,
	giphy: giphy__metadata_ts,
	googlecalendar: googlecalendar__metadata_ts,
	googlevideo: googlevideo__metadata_ts,
	granola: granola_config_json,
	"greetmate-ai": greetmate_ai_config_json,
	gtm: gtm_config_json,
	hitpay: hitpay_config_json,
	"horizon-workrooms": horizon_workrooms_config_json,
	hubspot: hubspot__metadata_ts,
	huddle01video: huddle01video__metadata_ts,
	"ics-feedcalendar": ics_feedcalendar_config_json,
	insihts: insihts_config_json,
	intercom: intercom_config_json,
	jelly: jelly_config_json,
	jitsivideo: jitsivideo__metadata_ts,
	larkcalendar: larkcalendar__metadata_ts,
	lindy: lindy_config_json,
	linear: linear_config_json,
	make: make_config_json,
	matomo: matomo_config_json,
	metapixel: metapixel_config_json,
	"millis-ai": millis_ai_config_json,
	mirotalk: mirotalk_config_json,
	"mock-payment-app": mock_payment_app_config_json,
	monobot: monobot_config_json,
	n8n: n8n_config_json,
	nextcloudtalk: nextcloudtalk_config_json,
	office365calendar: office365calendar__metadata_ts,
	office365video: office365video_config_json,
	paypal: paypal_config_json,
	ping: ping_config_json,
	pipedream: pipedream_config_json,
	"pipedrive-crm": pipedrive_crm_config_json,
	plausible: plausible_config_json,
	posthog: posthog_config_json,
	qr_code: qr_code_config_json,
	raycast: raycast_config_json,
	"retell-ai": retell_ai_config_json,
	riverside: riverside_config_json,
	roam: roam_config_json,
	"routing-forms": routing_forms_config_json,
	salesforce: salesforce_config_json,
	salesroom: salesroom_config_json,
	sendgrid: sendgrid_config_json,
	shimmervideo: shimmervideo_config_json,
	signal: signal_config_json,
	sirius_video: sirius_video_config_json,
	skype: skype_config_json,
	stripepayment: stripepayment__metadata_ts,
	sylapsvideo: sylapsvideo_config_json,
	synthflow: synthflow_config_json,
	tandemvideo: tandemvideo__metadata_ts,
	telegram: telegram_config_json,
	telli: telli_config_json,
	basic: basic_config_json,
	"booking-pages-tag": booking_pages_tag_config_json,
	"event-type-app-card": event_type_app_card_config_json,
	"event-type-location-video-static":
		event_type_location_video_static_config_json,
	"general-app-settings": general_app_settings_config_json,
	"link-as-an-app": link_as_an_app_config_json,
	twipla: twipla_config_json,
	umami: umami_config_json,
	vimcal: vimcal_config_json,
	vital: vital__metadata_ts,
	weather_in_your_calendar: weather_in_your_calendar_config_json,
	webex: webex_config_json,
	whatsapp: whatsapp_config_json,
	whereby: whereby_config_json,
	wipemycalother: wipemycalother__metadata_ts,
	wordpress: wordpress_config_json,
	zapier: zapier_config_json,
	"zoho-bigin": zoho_bigin_config_json,
	zohocalendar: zohocalendar_config_json,
	zohocrm: zohocrm_config_json,
	zoomvideo: zoomvideo__metadata_ts,
};
